import React, { useState } from "react";
import Checkbox from '@mui/material/Checkbox';
import { Box, Typography, Divider }  from '@mui/material';

import { MailConfirmButton } from "../style/button";
import { TypographyWithBr } from "../style/typography";
import { MailBoxCollapse } from "../style/collapse";
import { MailCheckFormControlLabel } from "../style/formControl";

export default function MailConfirm({isChecked, setIsChecked, mail_info}) {

    const [showEmailMlit, setShowEmailMlit] = useState(true);
    const [showEmailOitaG, setShowEmailOitaG] = useState(true);
    const [isCheckedMlit, setIsCheckedMlit] = useState(false);
    const [isCheckedOitaG, setIsCheckedOitaG] = useState(false);

    const toggleEmailPreviewMlit = () => setShowEmailMlit(prev => !prev);
    const toggleEmailPreviewOitaG = () => setShowEmailOitaG(prev => !prev);
    const handleCheckboxChangeMlit = (event) => {
        const newCheckedMlit = event.target.checked;
        setIsCheckedMlit(newCheckedMlit);
        // 両方のチェック状態を確認
        setIsChecked(newCheckedMlit && isCheckedOitaG);
        if (!newCheckedMlit) {
            setShowEmailMlit(true);
        } else {
            setShowEmailMlit(false);
        }
    };
    const handleCheckboxChangeOitaG = (event) => {
        const newCheckedOitaG = event.target.checked;
        setIsCheckedOitaG(newCheckedOitaG);
        // 両方のチェック状態を確認
        setIsChecked(isCheckedMlit && newCheckedOitaG);
        if (!newCheckedOitaG) {
            setShowEmailOitaG(true);
        } else {
            setShowEmailOitaG(false);
        }
    };

  return (
    <>
        <Box display="flex" flexDirection="column" gap={5}>
            <Box>
                <MailConfirmButton variant="contained" fullWidth onClick={toggleEmailPreviewMlit}>
                    国土交通省宛て報告メール
                </MailConfirmButton>
                <MailBoxCollapse in={showEmailMlit} timeout={500}>
                    <Box display="flex" flexDirection="column" gap={5}>
                        <Typography>
                        宛先メールアドレス：{mail_info?.mlit?.to.join(",　")}
                        </Typography>
                        <Divider />
                        <Typography>
                            件名：{mail_info?.mlit?.subject}
                        </Typography>
                        <Divider />
                        <TypographyWithBr>
                            {mail_info?.mlit?.body}
                        </TypographyWithBr>
                        <Divider />
                        <Typography>
                            添付ファイル：{mail_info?.mlit?.attachment}
                        </Typography>
                        <MailCheckFormControlLabel
                            control={<Checkbox checked={isCheckedMlit} onChange={handleCheckboxChangeMlit} />}
                            label="送付内容に同意する"
                        />
                    </Box>
                </MailBoxCollapse>
            </Box>
            <Box>
                <MailConfirmButton variant="contained" fullWidth onClick={toggleEmailPreviewOitaG}>
                    九電大分土木グループ宛て報告メール
                </MailConfirmButton>
                <MailBoxCollapse in={showEmailOitaG} timeout={500}>
                    <Box display="flex" flexDirection="column" gap={5}>
                        <Typography>
                            宛先メールアドレス：{mail_info?.oita_g?.to.join(",　")}
                        </Typography>
                        <Divider />
                        <Typography>
                            件名：{mail_info?.oita_g?.subject}
                        </Typography>
                        <Divider />
                        <TypographyWithBr>
                            {mail_info?.oita_g?.body}
                        </TypographyWithBr>
                        <Divider />
                        <Typography>
                            添付ファイル：{mail_info?.oita_g?.attachment}
                        </Typography>
                        <MailCheckFormControlLabel
                            control={<Checkbox checked={isCheckedOitaG} onChange={handleCheckboxChangeOitaG} />}
                            label="送付内容に同意する"
                        />
                    </Box>
                </MailBoxCollapse>
            </Box>
        </Box>
    </>
  );
}
